import React from "react";
import "./ArchiveConfirmationModal.scss";
import Modal from "react-bootstrap/Modal";
import calendarIcon from "../../../assets/calendar.svg";
import { Calendar } from "react-date-range";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import dateFormat from "dateformat";

class ArchiveConfirmationModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showDatePicker: false,
      selectedDate: this.getMinDate(),
      selectedDisplayDate: dateFormat(this.getMinDate(), "mmm dd, yyyy"),
    };

    this.datePickerRef = React.createRef();
    this.handleClickOutsideOfDatePicker = this.handleClickOutsideOfDatePicker.bind(
      this
    );
  }

  toggleDatePicker = () => {
    this.setState({ showDatePicker: !this.state.showDatePicker });
  };

  handleDateChange = (date) => {
    this.setState({
      showDatePicker: false,
      selectedDate: date,
      selectedDisplayDate: dateFormat(date, "mmm dd, yyyy"),
    });
  };

  componentDidUpdate(prevProps) {
    if (this.props !== prevProps) {
      this.setState({
        showDatePicker: false,
        selectedDate: this.getMinDate(),
        selectedDisplayDate: dateFormat(this.getMinDate(), "mmm dd, yyyy"),
      });
    }
  }

  componentDidMount() {
    document.addEventListener("mousedown", this.handleClickOutsideOfDatePicker);
  }

  componentWillUnmount() {
    document.removeEventListener(
      "mousedown",
      this.handleClickOutsideOfDatePicker
    );
  }

  handleClickOutsideOfDatePicker(event) {
    if (
      this.datePickerRef &&
      this.datePickerRef.current &&
      !this.datePickerRef.current.contains(event.target)
    ) {
      this.setState({ showDatePicker: false });
    }
  }

  getMinDate = () => {
    let date = new Date();
    date.setDate(date.getDate() + 1);
    return new Date(date);
  };

  render() {
    return (
      <Modal
        className="archive-confirmation-modal"
        size="sm"
        show={this.props.showModal}
        onHide={this.props.handleNoClick}
      >
        <div className="archive-confirmation-modal-content">
          <p className="title">Confirmation</p>
          {!this.props.archiveItemName ? (
            <p className="subtitle">
              Are you sure you want to archive {this.props.numberOfFiles}{" "} {this.props.isDocuments ? "document(s)" : "folders"}?
            </p>
          ) : (
            <p className="subtitle">
              Are you sure you want to archive{" "}
              <b>{this.props.archiveItemName}</b>?
            </p>
          )}

          <p className="label">Archive till</p>
          <div ref={this.datePickerRef}>
            <div className="date-holder" onClick={this.toggleDatePicker}>
              <span className="date">{this.state.selectedDisplayDate}</span>
              <img src={calendarIcon} alt="Calendar Icon" />
            </div>

            {this.state.showDatePicker ? (
              <div className="date-picker">
                <Calendar
                  date={this.state.selectedDate}
                  minDate={this.getMinDate()}
                  onChange={this.handleDateChange}
                />
              </div>
            ) : null}
          </div>
          <div className="footer">
            <button
              className="btn-secondary mr-4"
              onClick={this.props.handleNoClick}
            >
              No
            </button>
            <button
              className="btn-primary"
              onClick={() => {
                this.props.handleYesClick(this.state.selectedDisplayDate);
              }}
            >
              Yes
            </button>
          </div>
        </div>
      </Modal>
    );
  }
}

export default ArchiveConfirmationModal;
